import { render, staticRenderFns } from "./PosCart.vue?vue&type=template&id=20cf64b6&scoped=true"
import script from "./PosCart.vue?vue&type=script&lang=js"
export * from "./PosCart.vue?vue&type=script&lang=js"
import style0 from "./PosCart.vue?vue&type=style&index=0&id=20cf64b6&prod&lang=scss&scoped=true"
import style1 from "./PosCart.vue?vue&type=style&index=1&id=20cf64b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cf64b6",
  null
  
)

export default component.exports